import React from 'react';
import { Card, Empty } from 'antd';

/**
 * 收益分析
 * 职责：展示收益相关分析与图表；当前为占位页，后续接入收益模型与数据源。
 * 交互：暂无，后续支持指标切换与区间选择。
 */
const ProfitAnalysisPage = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>收益分析</h1>
      <Card>
        <Empty 
          description="收益分析功能开发中..."
          style={{ padding: '60px 0' }}
        />
      </Card>
    </div>
  );
};

export default ProfitAnalysisPage;
